export let data = {
  "avatar": "-1", //头像
  "nickname": "--", //昵称
  "gender": "male", //性别  male：男 ，female: 女
  "score": 0, //分数
  "sleep": { //睡眠相关
    "deep": 0, //深睡 ， 分
    "light": 0, //浅睡 ， 分
    "rem": 0, //REM 快速眼动睡眠 ， 分
    "awake": 0, //清醒 ， 分
    "nap": 0, //零星小睡
    "total": 0, //总时长 ， 分
    "quality": "-1", //睡眠质量， 2：良好 ，5：一般，6：差
    "score": 0,
    "tips": "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0", // 睡眠建议 1表示显示对应的建议
    "diff": 0 //区分新旧算法，5表示新算法
  },
  "sport": { //运动相关
    "duration": 0, //运动时长， 秒
    "step": 0, //步数
    "calorie": 0, //卡路里， kcal
    "speed": "0'0\"", //配速
    "pace": 0, //步频
    "distance": 0, //距离
    "heartRate": 0, //心率
    "level": "-1"
  },
  "rhr": {
    "avg": 0, //静态心率
    "level": "-1"
  },
  "dhr": {
    "avg": 0,
    "max": 0, //动态最大心率，运动心率
    "level": "-1"
  },
  "spo2h": {
    "avg": 0, //血氧饱和度
    "level": "-1"
  },
  "temperature": {
    "avg": 0, //体温
    "max": 0,
    "maxValueTime": "00:00", //如果没有体温，字段为 null
    "level": "-1"
  },
  "hrv": {
    "avg": 0, //心率变异性
    "level": "-1"
  },
  "excite": {
    "value": 0, //兴奋指数
    "level": "-1"
  },
  "vitality": {
    "value": 0, //活力指数
    "level": "-1"
  },
  "revovery": {
    "value": 0, //恢复指数
    "level": "-1"
  },
  "consumptive": {
    "value": 0, //消耗指数
    "level": "-1"
  },
  "ecg": {
    "exist": "-1"
  }
}

// 睡眠状况
export let sleep = {
  "-1": {
    "evaluation": "无睡眠数据。"
  },
  "1": {
    "evaluation": "如果一个人得不到充足的睡眠，整个人就会无精打采，久而久之身体健康也会受损。睡眠不好，会出现头痛、困倦乏力、精神萎靡、食欲不振、记忆力下降、反应迟钝、精神不集中等。因此，把心态放平，晚上的时间就留给自己休息的，放松身体和心情，好的睡眠让您拥有康健的体魄和愉悦的心情。"
  },
  "2": {
    "evaluation": "睡眠是保持健康必不可少的要素。俗话说药补不如食补，食补不如睡（水）补。长期缺乏睡眠将会扰乱生物钟，降低身体抵抗能力进入亚健康状态。请增加睡眠时间，提高睡眠效率，稳定作息习惯，同时补充水分，把身体调养至活力四射的状态。"
  },
  "3": {
    "evaluation": "运动、营养和睡眠是健康的三驾马车，请像爱护自己的眼睛一样注重睡眠。准时上床，定时休息，准时起床，维持正常的生活节律，提高睡眠品质，养成良好的作息习惯，保持健康的身体和愉悦的心情。"
  },
  "4": {
    "evaluation": "准时上床，定时休息，准时起床，有助于提高睡眠品质，养成良好的作息习惯，睡醒后在床上做一下拉伸运动，保持健康的身体和愉悦的心情。"
  },
  "5": {
    "evaluation": "科学睡眠，健康生活，永葆青春活力，请继续保持良好的生活习惯，享受幸福生活！"
  }
}
// 睡眠状况 男
export let sleepMale = {
  "-1": {
    "evaluation": "无睡眠数据",
    "suggest": "无睡眠数据。",
  },
  "1": {
    "evaluation": "差",
    "suggest": "如果一个人每天没有充足的睡眠，也就是睡眠时间短，那么整个人就会无精打采，久而久之身体健康也会受损。睡眠时长过短，容易出现头痛、困倦乏力、精神萎靡、食欲不振、记忆力下降、反应迟钝、精神不集中等。因此，把心态放宽，睡前的时间就道是留给睡觉的，什么都不要想，更不要想睡不着什么的给自己负面暗示。如果有午睡习惯，白天午睡时间控制在半小回时之类就可以。眠姿势要正确。朝右侧睡是科学的睡眠姿势。睡前可以洗个热水澡缓解压力，上床后做到全身放松。晚上睡觉前四小时不要吃东西，更不要喝茶或咖啡。平时少吃油腻食品，晚餐在7点半之前解决。晚餐尽量少吃，不能过油过饱。时多做运动，经常爬山或去健身房。有时间多旅行。睡前洗个热水澡后可以喝杯热牛奶，卧室的灯不宜太亮，最好是暖色调的，比如比较幽暗的暖黄色。"
  },
  "2": {
    "evaluation": "一般",
    "suggest": "睡眠时间过长与睡眠不足一样，都可导致神疲、体倦、代谢率降低,睡眠不宜过长，睡的时间过长后，心脏的跳动便会减慢，新陈代谢率亦会降得很低，肌肉组织松弛下来。因此，人的睡眠时间不宜过长，成年人昼夜7－8小时也就足够了。给自己设置好闹钟，早睡早起，规律作息，生活和工作都会变得更好。"
  },
  "3": {
    "evaluation": "良好",
    "suggest": "你的睡眠质量非常好，请继续保持。"
  }
}
// 睡眠状况 女
export let sleepFemale = {
  "-1": {
    "evaluation": "无睡眠数据",
    "suggest": "无睡眠数据。",
  },
  "1": {
    "evaluation": "差",
    "suggest": "睡眠不好多表现为入睡困难、浅睡、多梦、易醒，早醒、醒后再入睡困难等抄等，长期的睡眠不好，导致身体的各个机能得不到充足的休息，脑部的营养不足，白天工作起来没精神，身体疲劳感增加，精神涣散，头晕，头痛，胃痛，胃肠不适。所以睡前可以进行适量的有氧运动，可以出去散散步，慢走等慢运动，让身体放松有利于睡眠。保持轻松愉悦的心情，遇到事情以乐观积极的态度看待，事事不能扰了自己的愉悦没好心情。睡前少吃，睡前半小时不吃东西，过了八点不喝水，避免晚上起夜床。可在睡前半小时喝点牛奶，牛奶有利于睡眠。晚上一定记得不要喝咖啡浓茶等令大脑兴奋的事物，不要看一些场面激烈的图片跟电影，以免影响睡眠。"
  },
  "2": {
    "evaluation": "一般",
    "suggest": "正常成年人一般睡眠八个小时左右就可以，如果每一天睡眠时间过长以后，大脑也会缺氧，起床以后感觉浑身乏力，头晕目眩。对身体健康是有一定的危害的，所以充足而且适当的睡眠时间是保证身体健康是十分有益的。可以设置闹钟让自己的生物钟变得规律，早睡早起，精神百倍。"
  },
  "3": {
    "evaluation": "良好",
    "suggest": "你的睡眠质量非常好，请继续保持。"
  }
}
// 运动状况
export let sport = {
  "-1": {
    "evaluation": "无运动数据",
    "suggest": "无运动数据。",
  },
  "1": {
    "evaluation": "过少",
    "suggest": "生命在于运动，根据身体的状况不断地增加运动量，让身体处于保持活力的健康状态。"
  },
  "2": {
    "evaluation": "偏少",
    "suggest": "生命在于运动，根据身体的状况适度增加运动量，让身体处于活力四射的健康状态。"
  },
  "3": {
    "evaluation": "适中",
    "suggest": "生命在于运动，请继续保持合适的运动量，让身体处于活力四射的健康状态。"
  },
  "4": {
    "evaluation": "偏大",
    "suggest": "请注意身体感觉，量力而行，不要累着。"
  },
  "5": {
    "evaluation": "过大",
    "suggest": "请注意身体感觉，不要累着，减少运动量。"
  }
}

// 静态心率
export let rhr = {
  "-1": {
    "evaluation": "无静态心率数据",
    "suggest": "无静态心率数据。",
  },
  "1": {
    "evaluation": "过低",
    "suggest": "心脏是身体的发动机，请适度增加运动量，早睡早起，让身体机能处于良好的健康状态；如果感到心脏不适，请及时就医。"
  },
  "2": {
    "evaluation": "偏低",
    "suggest": "心脏是身体的发动机，请适度增加运动量，让身体机能处于良好的健康状态；如果您每天的运动量都很大，静态心率偏低正常现象，不用担心。"
  },
  "3": {
    "evaluation": "适中",
    "suggest": "心脏是身体的发动机，请继续保持当前的生活方式，让身体机能处于良好的健康状态。"
  },
  "4": {
    "evaluation": "偏高",
    "suggest": "请注意增加游泳、徒步等缓和的锻炼方式坚持锻炼，早睡早起，不要累着，锻炼心肺功能。"
  },
  "5": {
    "evaluation": "过高",
    "suggest": "请注意增加游泳、徒步等缓和的锻炼方式坚持锻炼，不要累着，锻炼心肺功能；如果感到心脏不适，请及时就医。"
  }
}

// 运动心率
export let dhr = {
  "-1": {
    "evaluation": "无运动心率数据",
    "suggest": "无运动心率数据。",
  },
  "1": {
    "evaluation": "偏低",
    "suggest": "心脏是身体的发动机，请适度增加运动量，让心脏机能处于合理的状态。"
  },
  "2": {
    "evaluation": "适中",
    "suggest": "保持当前的运动强度，让心脏处于健康的工作范围。"
  },
  "3": {
    "evaluation": "偏高",
    "suggest": "请注意运动强度，适当降低运动强度，不要给心脏带来过重的压力。可以增加游泳、徒步等缓和的锻炼方式坚持锻炼，提高心肺功能。"
  }
}

// 血氧浓度
export let spo2h = {
  "-1": {
    "evaluation": "无血氧浓度数据",
    "suggest": "无血氧浓度数据。",
  },
  "1": {
    "evaluation": "过低",
    "suggest": "心肺功能是身体能量提供的源泉，根据身体的状况适度增加运动量，增强心肺功能；如果有感觉胸闷、发力等不适，请及时就医。"
  },
  "2": {
    "evaluation": "偏低",
    "suggest": "心肺功能是身体能量提供的源泉，根据身体的状况适度增加运动量，增强心肺功能。"
  },
  "3": {
    "evaluation": "正常",
    "suggest": "请继续保持良好的身体状态。"
  }
}

// 体温
export let temperature = {
  "-1": {
    "evaluation": "无体温数据",
    "suggest": "无体温数据。",
  },
  "1": {
    "evaluation": "正常",
    "suggest": "请继续保持良好的生活习惯。"
  },
  "2": {
    "evaluation": "偏高",
    "suggest": "请使用医用体温计测下体温，如果高于37.0度请及时就医。"
  },
}

// 心率变异性
export let hrv = {
  "-1": {
    "evaluation": "无心率变异性数据",
    "suggest": "无心率变异性数据。",
  },
  "1": {
    "evaluation": "偏低",
    "suggest": "请适当增加体育锻炼，保持活力。"
  },
  "2": {
    "evaluation": "正常",
    "suggest": "请保持健康的生活习惯，劳逸结合。"
  },
  "3": {
    "evaluation": "偏高",
    "suggest": "请注意休息，健康饮食。如果有感觉不适或者经常偏高请及时就医。"
  }
}

// 兴奋指数
export let excite = {
  "-1": {
    "evaluation": "无兴奋数据",
    "suggest": "无兴奋数据。",
  },
  "1": {
    "evaluation": "平静",
    "suggest": "目前心情平静。尽可能的从事一些体育活动或者琴棋书画陶冶情操，生活中有很多美好的东西等着您去发现。"
  },
  "2": {
    "evaluation": "舒适",
    "suggest": "当前心态放松，每天进步一点点，集腋成裘，坚持长久便可成大事。"
  },
  "3": {
    "evaluation": "兴奋",
    "suggest": "当前有些兴奋，注意控制情绪，兴奋的同时有一个清醒的头脑和平常心。"
  }
}

// 活力指数
export let vitality = {
  "-1": {
    "evaluation": "无活力数据",
    "suggest": "无活力数据。",
  },
  "1": {
    "evaluation": "缺乏活力",
    "suggest": "请注意调节生活方式，每天适度运动，放松心态，保持身心健康。"
  },
  "2": {
    "evaluation": "活力正常",
    "suggest": "请注意调节生活方式，每天适度运动，放松心态，保持身心健康。"
  },
  "3": {
    "evaluation": "活力四射",
    "suggest": "请继续保持健康的生活、娱乐和锻炼活动。"
  }
}

// 恢复指数
export let revovery = {
  "-1": {
    "evaluation": "无恢复数据",
    "suggest": "无恢复数据。",
  },
  "1": {
    "evaluation": "差",
    "suggest": "请保证每天足够的睡眠时间和睡眠质量，每天适当的运动。"
  },
  "2": {
    "evaluation": "偏差",
    "suggest": "请保证每天足够的睡眠时间和睡眠质量，每天适当的运动。"
  },
  "3": {
    "evaluation": "一般",
    "suggest": "请保证每天足够的睡眠时间和睡眠质量，每天适当的运动。"
  },
  "4": {
    "evaluation": "良好",
    "suggest": "请继续保持每天足够的睡眠时间和睡眠质量，每天适当的运动。"
  },
  "5": {
    "evaluation": "非常棒",
    "suggest": "请继续保持每天足够的睡眠时间和睡眠质量，每天适当的运动。"
  }
}

// 消耗指数
export let consumptive = {
  "-1": {
    "evaluation": "无消耗数据",
    "suggest": "无消耗数据。",
  },
  "1": {
    "evaluation": "很少",
    "suggest": "请增加每天的运动量，保证每天足够的睡眠时间和睡眠质量。"
  },
  "2": {
    "evaluation": "正常",
    "suggest": "请继续保持每天足够的睡眠时间和睡眠质量，每天适当的运动。"
  },
  "3": {
    "evaluation": "偏大",
    "suggest": "请保证每天有足够的睡眠时间和睡眠质量，每天适当的运动。"
  },
  "4": {
    "evaluation": "过大",
    "suggest": "根据身体条件合理运动，以不感觉疲劳影响第二天工作为止，请保证每天有足够的睡眠时间和睡眠质量。"
  }
}

// 总评
export let getSuggest1 = [
  "请改变不良的生活方式，每天适量运动，按时睡眠，养成良好的生活习惯，维持健康的身体和愉悦的心情",
  "请改变不良的生活方式，每天适量运动，按时睡眠，养成良好的生活习惯，维持健康的身体和愉悦的心情",
  "请适量运动，按时睡眠，养成良好的生活习惯，维持健康的身体和愉悦的心情",
  "请适量运动，按时睡眠，养成良好的生活习惯，维持健康的身体和愉悦的心情",
  "请继续保持良好的生活习惯，维持健康的身体和愉悦的心情"
]

// 总评ECG测量
export let getSuggest2 = [
  "心脏是人体君主之官，测量ECG能够直观反映心脏健康。请每日至少一次测量ECG，有助于提高评估健康指数的准确度，同时呵护心脏健康。",
  "心脏是人体君主之官，测量ECG能够直观反映心脏健康。请保持每天至少一次ECG测量，监护心脏健康。"
]

// 总评睡眠
export let getSuggest3 = [
  "睡眠是恢复体力和精神的必须过程，你的睡眠很差，长久下去将会严重影响身体健康， 请保持规律的作息习惯， 心态平和， 有益于身心健康。 ",
  "睡眠是恢复体力和精神的必须过程，请保持规律的作息习惯，心态平和， 有益于身心健康。 ",
  "睡眠是恢复体力和精神的必须过程，请保持良好的睡眠习惯。"
]

// 总评步数
export let getSuggest4 = [
  "生命在于运动，每天请根据自己身体的实际情况保持6000步以上的运动量，有助于保持身体活力。",
  "你的活动量适中，有助于保持身体活力，请继续保持。",
  "请适量运动，不要超出身体所能承受的运动总量和运动强度。力所能及的运动有助于保持身体活力。"
]


// 总评SNDD
export let getSuggest5 = [
  "请注意保护心脏，每天做些慢跑、快走、游泳之类不需要爆发力的运动，和朋友一起做些琴棋书画、唱歌之类的休闲娱乐活动，抽时间陪伴亲人、朋友，不要有太大的心理压力，保证睡眠，提高心脏机能和活力。",
  "您的心脏机能很好，保持良好的生活习惯，劳逸结合，保持身体健康和心情愉悦。",
  "请注意保护心脏，每天做些慢跑、快走、游泳之类不需要爆发力的运动，和朋友一起做些琴棋书画、唱歌之类的休闲娱乐活动，同亲人、朋友多联系，生活中有很多美好的事情可以去寻找，保证睡眠，保持心脏机能和活力。"
]

export let sleepInfo = [
  "今天睡眠时间太少，需要增加睡眠恢复身体和大脑。",
  "睡眠时间偏少，为了保持良好的身心状态，需要增加睡眠时间。",
  "睡眠时间合适。",
  "睡眠时间偏多，为白天安排一些有趣的工作或者娱乐，劳逸结合身体会更好。",
  "睡眠时间过多，这样浑浑噩噩的生活不能再这样继续下去啦。",
  "上床时间较晚，最好在0点之前进入睡眠。",
  "上床时间太晚，容易生物钟混乱，黑白颠倒。最好在0点之前进入睡眠。",
  "在适合午睡的时间点睡觉。除了午休之外还要保证每天的主睡眠更重要。",
  "在适合工作、运动和交友的时间段上床睡觉，容易黑白颠倒扰乱生物钟，请保证每天的主睡眠。",
  "上床时间稍早，可以睡前泡脚半个小时，缓和心情后上床。",
  "上床睡觉时间合适。",
  "上床睡觉时间可以，最好提前半个小时开始睡觉。",
  "虽说三更灯火五更鸡，可是睡眠对健康非常好重要。磨刀不误砍柴工，晚一点起床保证睡眠的时间，养成良好的作息习惯，效率会更高，身体会更好。",
  "您起来的非常早，虽然早起的鸟儿有虫吃，可是早起的虫儿被鸟吃。早上醒来后可以在床上做些拉伸和伸展锻炼，等到太阳光线能够照到大地上再起床。",
  "起床时间非常合适，跟随大自然的节奏开始一天的活动。",
  "在身体恢复良好的情况下可以提前一个小时起床状态更佳。",
  "今天赖床了，太阳公公明天等着跟您一起晨练呢。",
  "在今天这个时间点起床，容易黑白颠倒扰乱生物钟，请保证每天的主睡眠。",
  "在适合午睡的时间点睡觉起床。除了午休之外还要保证每天的主睡眠更重要。"
]

export let areaCode = [{
  "short": "AD",
  "name": "安道尔共和国",
  "en": "Andorra",
  "tel": "376",
  "letter": "A"
}, {
  "short": "AE",
  "name": "阿拉伯联合酋长国",
  "en": "United Arab Emirates",
  "tel": "971",
  "letter": "A"
}, {
  "short": "AF",
  "name": "阿富汗",
  "en": "Afghanistan",
  "tel": "93",
  "letter": "A"
}, {
  "short": "AG",
  "name": "安提瓜和巴布达",
  "en": "Antigua and Barbuda",
  "tel": "1268",
  "letter": "A"
}, {
  "short": "AI",
  "name": "安圭拉岛",
  "en": "Anguilla",
  "tel": "1264",
  "letter": "A"
}, {
  "short": "AL",
  "name": "阿尔巴尼亚",
  "en": "Albania",
  "tel": "355",
  "letter": "A"
}, {
  "short": "AM",
  "name": "亚美尼亚",
  "en": "Armenia",
  "tel": "374",
  "letter": "Y"
}, {
  "short": "",
  "name": "阿森松",
  "en": "Ascension",
  "tel": "247",
  "letter": "A"
}, {
  "short": "AO",
  "name": "安哥拉",
  "en": "Angola",
  "tel": "244",
  "letter": "A"
}, {
  "short": "AR",
  "name": "阿根廷",
  "en": "Argentina",
  "tel": "54",
  "letter": "A"
}, {
  "short": "AT",
  "name": "奥地利",
  "en": "Austria",
  "tel": "43",
  "letter": "A"
}, {
  "short": "AU",
  "name": "澳大利亚",
  "en": "Australia",
  "tel": "61",
  "letter": "A"
}, {
  "short": "AZ",
  "name": "阿塞拜疆",
  "en": "Azerbaijan",
  "tel": "994",
  "letter": "A"
}, {
  "short": "BB",
  "name": "巴巴多斯",
  "en": "Barbados",
  "tel": "1246",
  "letter": "B"
}, {
  "short": "BD",
  "name": "孟加拉国",
  "en": "Bangladesh",
  "tel": "880",
  "letter": "M"
}, {
  "short": "BE",
  "name": "比利时",
  "en": "Belgium",
  "tel": "32",
  "letter": "B"
}, {
  "short": "BF",
  "name": "布基纳法索",
  "en": "Burkina-faso",
  "tel": "226",
  "letter": "B"
}, {
  "short": "BG",
  "name": "保加利亚",
  "en": "Bulgaria",
  "tel": "359",
  "letter": "B"
}, {
  "short": "BH",
  "name": "巴林",
  "en": "Bahrain",
  "tel": "973",
  "letter": "B"
}, {
  "short": "BI",
  "name": "布隆迪",
  "en": "Burundi",
  "tel": "257",
  "letter": "B"
}, {
  "short": "BJ",
  "name": "贝宁",
  "en": "Benin",
  "tel": "229",
  "letter": "B"
}, {
  "short": "BM",
  "name": "百慕大群岛",
  "en": "Bermuda Is.",
  "tel": "1441",
  "letter": "B"
}, {
  "short": "BN",
  "name": "文莱",
  "en": "Brunei",
  "tel": "673",
  "letter": "W"
}, {
  "short": "BO",
  "name": "玻利维亚",
  "en": "Bolivia",
  "tel": "591",
  "letter": "B"
}, {
  "short": "BR",
  "name": "巴西",
  "en": "Brazil",
  "tel": "55",
  "letter": "B"
}, {
  "short": "BS",
  "name": "巴哈马",
  "en": "Bahamas",
  "tel": "1242",
  "letter": "B"
}, {
  "short": "BW",
  "name": "博茨瓦纳",
  "en": "Botswana",
  "tel": "267",
  "letter": "B"
}, {
  "short": "BY",
  "name": "白俄罗斯",
  "en": "Belarus",
  "tel": "375",
  "letter": "B"
}, {
  "short": "BZ",
  "name": "伯利兹",
  "en": "Belize",
  "tel": "501",
  "letter": "B"
}, {
  "short": "CA",
  "name": "加拿大",
  "en": "Canada",
  "tel": "1",
  "letter": "J"
}, {
  "short": "",
  "name": "开曼群岛",
  "en": "Cayman Is.",
  "tel": "1345",
  "letter": "K"
}, {
  "short": "CF",
  "name": "中非共和国",
  "en": "Central African Republic",
  "tel": "236",
  "letter": "Z"
}, {
  "short": "CG",
  "name": "刚果",
  "en": "Congo",
  "tel": "242",
  "letter": "G"
}, {
  "short": "CH",
  "name": "瑞士",
  "en": "Switzerland",
  "tel": "41",
  "letter": "R"
}, {
  "short": "CK",
  "name": "库克群岛",
  "en": "Cook Is.",
  "tel": "682",
  "letter": "K"
}, {
  "short": "CL",
  "name": "智利",
  "en": "Chile",
  "tel": "56",
  "letter": "Z"
}, {
  "short": "CM",
  "name": "喀麦隆",
  "en": "Cameroon",
  "tel": "237",
  "letter": "K"
}, {
  "short": "CN",
  "name": "中国",
  "en": "China",
  "tel": "86",
  "letter": "Z"
}, {
  "short": "CO",
  "name": "哥伦比亚",
  "en": "Colombia",
  "tel": "57",
  "letter": "G"
}, {
  "short": "CR",
  "name": "哥斯达黎加",
  "en": "Costa Rica",
  "tel": "506",
  "letter": "G"
},
{
  "short": "CU",
  "name": "古巴",
  "en": "Cuba",
  "tel": "53",
  "letter": "G"
}, {
  "short": "CY",
  "name": "塞浦路斯",
  "en": "Cyprus",
  "tel": "357",
  "letter": "S"
}, {
  "short": "CZ",
  "name": "捷克",
  "en": "Czech Republic",
  "tel": "420",
  "letter": "J"
}, {
  "short": "DJ",
  "name": "吉布提",
  "en": "Djibouti",
  "tel": "253",
  "letter": "J"
}, {
  "short": "DK",
  "name": "丹麦",
  "en": "Denmark",
  "tel": "45",
  "letter": "D"
}, {
  "short": "DO",
  "name": "多米尼加共和国",
  "en": "Dominica Rep.",
  "tel": "1890",
  "letter": "D"
}, {
  "short": "DZ",
  "name": "阿尔及利亚",
  "en": "Algeria",
  "tel": "213",
  "letter": "A"
}, {
  "short": "EC",
  "name": "厄瓜多尔",
  "en": "Ecuador",
  "tel": "593",
  "letter": "E"
}, {
  "short": "EE",
  "name": "爱沙尼亚",
  "en": "Estonia",
  "tel": "372",
  "letter": "A"
}, {
  "short": "EG",
  "name": "埃及",
  "en": "Egypt",
  "tel": "20",
  "letter": "A"
}, {
  "short": "ES",
  "name": "西班牙",
  "en": "Spain",
  "tel": "34",
  "letter": "X"
}, {
  "short": "ET",
  "name": "埃塞俄比亚",
  "en": "Ethiopia",
  "tel": "251",
  "letter": "A"
}, {
  "short": "FI",
  "name": "芬兰",
  "en": "Finland",
  "tel": "358",
  "letter": "F"
}, {
  "short": "FJ",
  "name": "斐济",
  "en": "Fiji",
  "tel": "679",
  "letter": "F"
}, {
  "short": "FR",
  "name": "法国",
  "en": "France",
  "tel": "33",
  "letter": "F"
},  {
  "short": "GB",
  "name": "英国",
  "en": "United Kiongdom",
  "tel": "44",
  "letter": "Y"
}, {
  "short": "GF",
  "name": "法属圭亚那",
  "en": "French Guiana",
  "tel": "594",
  "letter": "F"
}, {
  "short": "GA",
  "name": "加蓬",
  "en": "Gabon",
  "tel": "241",
  "letter": "J"
},
{
  "short": "GD",
  "name": "格林纳达",
  "en": "Grenada",
  "tel": "1809",
  "letter": "G"
}, {
  "short": "GE",
  "name": "格鲁吉亚",
  "en": "Georgia",
  "tel": "995",
  "letter": "G"
}, {
  "short": "DE",
  "name": "德国",
  "en": "Germany",
  "tel": "49",
  "letter": "D"
}, {
  "short": "GH",
  "name": "加纳",
  "en": "Ghana",
  "tel": "233",
  "letter": "J"
}, {
  "short": "GI",
  "name": "直布罗陀",
  "en": "Gibraltar",
  "tel": "350",
  "letter": "Z"
}, {
  "short": "GM",
  "name": "冈比亚",
  "en": "Gambia",
  "tel": "220",
  "letter": "G"
}, {
  "short": "GN",
  "name": "几内亚",
  "en": "Guinea",
  "tel": "224",
  "letter": "J"
}, {
  "short": "GR",
  "name": "希腊",
  "en": "Greece",
  "tel": "30",
  "letter": "X"
}, {
  "short": "GT",
  "name": "危地马拉",
  "en": "Guatemala",
  "tel": "502",
  "letter": "W"
}, {
  "short": "GU",
  "name": "关岛",
  "en": "Guam",
  "tel": "1671",
  "letter": "G"
}, {
  "short": "GY",
  "name": "圭亚那",
  "en": "Guyana",
  "tel": "592",
  "letter": "G"
}, {
  "short": "ChinaHK",
  "name": "中国香港特别行政区",
  "en": "China Hongkong",
  "tel": "852",
  "letter": "Z"
}, {
  "short": "HN",
  "name": "洪都拉斯",
  "en": "Honduras",
  "tel": "504",
  "letter": "H"
}, {
  "short": "HT",
  "name": "海地",
  "en": "Haiti",
  "tel": "509",
  "letter": "H"
}, {
  "short": "HU",
  "name": "匈牙利",
  "en": "Hungary",
  "tel": "36",
  "letter": "X"
}, {
  "short": "ID",
  "name": "印度尼西亚",
  "en": "Indonesia",
  "tel": "62",
  "letter": "Y"
}, {
  "short": "IE",
  "name": "爱尔兰",
  "en": "Ireland",
  "tel": "353",
  "letter": "A"
}, {
  "short": "IL",
  "name": "以色列",
  "en": "Israel",
  "tel": "972",
  "letter": "Y"
}, {
  "short": "IN",
  "name": "印度",
  "en": "India",
  "tel": "91",
  "letter": "Y"
}, {
  "short": "IQ",
  "name": "伊拉克",
  "en": "Iraq",
  "tel": "964",
  "letter": "Y"
}, {
  "short": "IR",
  "name": "伊朗",
  "en": "Iran",
  "tel": "98",
  "letter": "Y"
}, {
  "short": "IS",
  "name": "冰岛",
  "en": "Iceland",
  "tel": "354",
  "letter": "B"
}, {
  "short": "IT",
  "name": "意大利",
  "en": "Italy",
  "tel": "39",
  "letter": "Y"
}, {
  "short": "",
  "name": "科特迪瓦",
  "en": "Ivory Coast",
  "tel": "225",
  "letter": "K"
}, {
  "short": "JM",
  "name": "牙买加",
  "en": "Jamaica",
  "tel": "1876",
  "letter": "Y"
}, {
  "short": "JO",
  "name": "约旦",
  "en": "Jordan",
  "tel": "962",
  "letter": "Y"
}, {
  "short": "JP",
  "name": "日本",
  "en": "Japan",
  "tel": "81",
  "letter": "R"
}, {
  "short": "KE",
  "name": "肯尼亚",
  "en": "Kenya",
  "tel": "254",
  "letter": "K"
}, {
  "short": "KG",
  "name": "吉尔吉斯坦",
  "en": "Kyrgyzstan",
  "tel": "331",
  "letter": "J"
}, {
  "short": "KH",
  "name": "柬埔寨",
  "en": "Kampuchea (Cambodia )",
  "tel": "855",
  "letter": "J"
}, {
  "short": "KP",
  "name": "朝鲜",
  "en": "North Korea",
  "tel": "850",
  "letter": "C"
}, {
  "short": "KR",
  "name": "韩国",
  "en": "Korea",
  "tel": "82",
  "letter": "H"
}, {
  "short": "KT",
  "name": "科特迪瓦共和国",
  "en": "RepublicofIvoryCoast",
  "tel": "225",
  "letter": "K"
}, {
  "short": "KW",
  "name": "科威特",
  "en": "Kuwait",
  "tel": "965",
  "letter": "K"
}, {
  "short": "KZ",
  "name": "哈萨克斯坦",
  "en": "Kazakstan",
  "tel": "327",
  "letter": "H"
}, {
  "short": "LA",
  "name": "老挝",
  "en": "Laos",
  "tel": "856",
  "letter": "L"
}, {
  "short": "LB",
  "name": "黎巴嫩",
  "en": "Lebanon",
  "tel": "961",
  "letter": "L"
}, {
  "short": "LC",
  "name": "圣卢西亚",
  "en": "Saint Lueia",
  "tel": "1758",
  "letter": "S"
}, {
  "short": "LI",
  "name": "列支敦士登",
  "en": "Liechtenstein",
  "tel": "423",
  "letter": "L"
}, {
  "short": "LK",
  "name": "斯里兰卡",
  "en": "Sri Lanka",
  "tel": "94",
  "letter": "S"
}, {
  "short": "LR",
  "name": "利比里亚",
  "en": "Liberia",
  "tel": "231",
  "letter": "L"
}, {
  "short": "LS",
  "name": "莱索托",
  "en": "Lesotho",
  "tel": "266",
  "letter": "L"
}, {
  "short": "LT",
  "name": "立陶宛",
  "en": "Lithuania",
  "tel": "370",
  "letter": "L"
}, {
  "short": "LU",
  "name": "卢森堡",
  "en": "Luxembourg",
  "tel": "352",
  "letter": "L"
}, {
  "short": "LV",
  "name": "拉脱维亚",
  "en": "Latvia",
  "tel": "371",
  "letter": "L"
}, {
  "short": "LY",
  "name": "利比亚",
  "en": "Libya",
  "tel": "218",
  "letter": "L"
}, {
  "short": "MA",
  "name": "摩洛哥",
  "en": "Morocco",
  "tel": "212",
  "letter": "M"
}, {
  "short": "MC",
  "name": "摩纳哥",
  "en": "Monaco",
  "tel": "377",
  "letter": "M"
}, {
  "short": "MD",
  "name": "摩尔多瓦",
  "en": "Moldova Republic of",
  "tel": "373",
  "letter": "M"
}, {
  "short": "MG",
  "name": "马达加斯加",
  "en": "Madagascar",
  "tel": "261",
  "letter": "M"
}, {
  "short": "ML",
  "name": "马里",
  "en": "Mali",
  "tel": "223",
  "letter": "M"
}, {
  "short": "MM",
  "name": "缅甸",
  "en": "Burma",
  "tel": "95",
  "letter": "M"
}, {
  "short": "MN",
  "name": "蒙古",
  "en": "Mongolia",
  "tel": "976",
  "letter": "M"
}, {
  "short": "china MO",
  "name": "中国澳门",
  "en": "China Macao",
  "tel": "853",
  "letter": "Z"
}, {
  "short": "MS",
  "name": "蒙特塞拉特岛",
  "en": "Montserrat Is",
  "tel": "1664",
  "letter": "M"
}, {
  "short": "MT",
  "name": "马耳他",
  "en": "Malta",
  "tel": "356",
  "letter": "M"
}, {
  "short": "",
  "name": "马里亚那群岛",
  "en": "MarianaIs",
  "tel": "1670",
  "letter": "M"
}, {
  "short": "",
  "name": "马提尼克",
  "en": "Martinique",
  "tel": "596",
  "letter": "M"
}, {
  "short": "MU",
  "name": "毛里求斯",
  "en": "Mauritius",
  "tel": "230",
  "letter": "M"
}, {
  "short": "MV",
  "name": "马尔代夫",
  "en": "Maldives",
  "tel": "960",
  "letter": "M"
}, {
  "short": "MW",
  "name": "马拉维",
  "en": "Malawi",
  "tel": "265",
  "letter": "M"
}, {
  "short": "MX",
  "name": "墨西哥",
  "en": "Mexico",
  "tel": "52",
  "letter": "M"
}, {
  "short": "MY",
  "name": "马来西亚",
  "en": "Malaysia",
  "tel": "60",
  "letter": "M"
}, {
  "short": "MZ",
  "name": "莫桑比克",
  "en": "Mozambique",
  "tel": "258",
  "letter": "M"
}, {
  "short": "NA",
  "name": "纳米比亚",
  "en": "Namibia",
  "tel": "264",
  "letter": "N"
}, {
  "short": "NE",
  "name": "尼日尔",
  "en": "Niger",
  "tel": "977",
  "letter": "N"
}, {
  "short": "NG",
  "name": "尼日利亚",
  "en": "Nigeria",
  "tel": "234",
  "letter": "N"
}, {
  "short": "NI",
  "name": "尼加拉瓜",
  "en": "Nicaragua",
  "tel": "505",
  "letter": "N"
}, {
  "short": "NL",
  "name": "荷兰",
  "en": "Netherlands",
  "tel": "31",
  "letter": "H"
}, {
  "short": "NO",
  "name": "挪威",
  "en": "Norway",
  "tel": "47",
  "letter": "N"
}, {
  "short": "NP",
  "name": "尼泊尔",
  "en": "Nepal",
  "tel": "977",
  "letter": "N"
}, {
  "short": "",
  "name": "荷属安的列斯",
  "en": "Netheriands Antilles",
  "tel": "599",
  "letter": "H"
}, {
  "short": "NR",
  "name": "瑙鲁",
  "en": "Nauru",
  "tel": "674",
  "letter": "N"
}, {
  "short": "NZ",
  "name": "新西兰",
  "en": "New Zealand",
  "tel": "64",
  "letter": "X"
}, {
  "short": "OM",
  "name": "阿曼",
  "en": "Oman",
  "tel": "968",
  "letter": "A"
},  {
  "short": "BL",
  "name": "巴勒斯坦",
  "en": "Palestine",
  "tel": "970",
  "letter": "B"
},{
  "short": "PA",
  "name": "巴拿马",
  "en": "Panama",
  "tel": "507",
  "letter": "B"
}, {
  "short": "PE",
  "name": "秘鲁",
  "en": "Peru",
  "tel": "51",
  "letter": "M"
}, {
  "short": "PF",
  "name": "法属玻利尼西亚",
  "en": "French Polynesia",
  "tel": "689",
  "letter": "F"
}, {
  "short": "PG",
  "name": "巴布亚新几内亚",
  "en": "Papua New Cuinea",
  "tel": "675",
  "letter": "B"
}, {
  "short": "PH",
  "name": "菲律宾",
  "en": "Philippines",
  "tel": "63",
  "letter": "F"
}, {
  "short": "PK",
  "name": "巴基斯坦",
  "en": "Pakistan",
  "tel": "92",
  "letter": "B"
}, {
  "short": "PL",
  "name": "波兰",
  "en": "Poland",
  "tel": "48",
  "letter": "B"
}, {
  "short": "PR",
  "name": "波多黎各",
  "en": "Puerto Rico",
  "tel": "1787",
  "letter": "B"
}, {
  "short": "PT",
  "name": "葡萄牙",
  "en": "Portugal",
  "tel": "351",
  "letter": "P"
}, {
  "short": "PY",
  "name": "巴拉圭",
  "en": "Paraguay",
  "tel": "595",
  "letter": "B"
}, {
  "short": "QA",
  "name": "卡塔尔",
  "en": "Qatar",
  "tel": "974",
  "letter": "K"
}, {
  "short": "",
  "name": "留尼旺",
  "en": "Reunion",
  "tel": "262",
  "letter": "L"
}, {
  "short": "RO",
  "name": "罗马尼亚",
  "en": "Romania",
  "tel": "40",
  "letter": "L"
}, {
  "short": "RU",
  "name": "俄罗斯",
  "en": "Russia",
  "tel": "7",
  "letter": "E"
}, {
  "short": "SA",
  "name": "沙特阿拉伯",
  "en": "Saudi Arabia",
  "tel": "966",
  "letter": "S"
}, {
  "short": "SB",
  "name": "所罗门群岛",
  "en": "Solomon Is",
  "tel": "677",
  "letter": "S"
}, {
  "short": "SC",
  "name": "塞舌尔",
  "en": "Seychelles",
  "tel": "248",
  "letter": "S"
}, {
  "short": "SD",
  "name": "苏丹",
  "en": "Sudan",
  "tel": "249",
  "letter": "S"
}, {
  "short": "SE",
  "name": "瑞典",
  "en": "Sweden",
  "tel": "46",
  "letter": "R"
}, {
  "short": "SG",
  "name": "新加坡",
  "en": "Singapore",
  "tel": "65",
  "letter": "X"
}, {
  "short": "SI",
  "name": "斯洛文尼亚",
  "en": "Slovenia",
  "tel": "386",
  "letter": "S"
}, {
  "short": "SK",
  "name": "斯洛伐克",
  "en": "Slovakia",
  "tel": "421",
  "letter": "S"
}, {
  "short": "SL",
  "name": "塞拉利昂",
  "en": "Sierra Leone",
  "tel": "232",
  "letter": "S"
}, {
  "short": "SM",
  "name": "圣马力诺",
  "en": "San Marino",
  "tel": "378",
  "letter": "S"
}, {
  "short": "",
  "name": "东萨摩亚(美)",
  "en": "Samoa Eastern",
  "tel": "684",
  "letter": "D"
}, {
  "short": "",
  "name": "西萨摩亚",
  "en": "Samoa Western",
  "tel": "685",
  "letter": "X"
}, {
  "short": "SN",
  "name": "塞内加尔",
  "en": "Senegal",
  "tel": "221",
  "letter": "S"
}, {
  "short": "SO",
  "name": "索马里",
  "en": "Somali",
  "tel": "252",
  "letter": "S"
}, {
  "short": "SR",
  "name": "苏里南",
  "en": "Suriname",
  "tel": "597",
  "letter": "S"
}, {
  "short": "ST",
  "name": "圣多美和普林西比",
  "en": "Sao Tome and Principe",
  "tel": "239",
  "letter": "S"
}, {
  "short": "SV",
  "name": "萨尔瓦多",
  "en": "EI Salvador",
  "tel": "503",
  "letter": "S"
}, {
  "short": "SY",
  "name": "叙利亚",
  "en": "Syria",
  "tel": "963",
  "letter": "S"
}, {
  "short": "SZ",
  "name": "斯威士兰",
  "en": "Swaziland",
  "tel": "268",
  "letter": "S"
},{
  "short": "TG",
  "name": "多哥",
  "en": "Togo",
  "tel": "228",
  "letter": "D"
}, {
  "short": "TH",
  "name": "泰国",
  "en": "Thailand",
  "tel": "66",
  "letter": "T"
}, {
  "short": "TJ",
  "name": "塔吉克斯坦",
  "en": "Tajikstan",
  "tel": "992",
  "letter": "T"
}, {
  "short": "TM",
  "name": "土库曼斯坦",
  "en": "Turkmenistan",
  "tel": "993",
  "letter": "T"
}, {
  "short": "TN",
  "name": "突尼斯",
  "en": "Tunisia",
  "tel": "216",
  "letter": "T"
}, {
  "short": "TO",
  "name": "汤加",
  "en": "Tonga",
  "tel": "676",
  "letter": "T"
}, {
  "short": "TR",
  "name": "土耳其",
  "en": "Turkey",
  "tel": "90",
  "letter": "T"
}, {
  "short": "TT",
  "name": "特立尼达和多巴哥",
  "en": "Trinidad and Tobago",
  "tel": "1809",
  "letter": "T"
}, {
  "short": "china TW",
  "name": "中国台湾省",
  "en": "China Taiwan",
  "tel": "886",
  "letter": "Z"
}, {
  "short": "TZ",
  "name": "坦桑尼亚",
  "en": "Tanzania",
  "tel": "255",
  "letter": "T"
}, {
  "short": "UA",
  "name": "乌克兰",
  "en": "Ukraine",
  "tel": "380",
  "letter": "W"
}, {
  "short": "UG",
  "name": "乌干达",
  "en": "Uganda",
  "tel": "256",
  "letter": "W"
}, {
  "short": "US",
  "name": "美国",
  "en": "United States of America",
  "tel": "1",
  "letter": "M"
}, {
  "short": "UY",
  "name": "乌拉圭",
  "en": "Uruguay",
  "tel": "598",
  "letter": "W"
}, {
  "short": "UZ",
  "name": "乌兹别克斯坦",
  "en": "Uzbekistan",
  "tel": "233",
  "letter": "W"
}, {
  "short": "VC",
  "name": "圣文森特岛",
  "en": "Saint Vincent",
  "tel": "1784",
  "letter": "S"
}, {
  "short": "VE",
  "name": "委内瑞拉",
  "en": "Venezuela",
  "tel": "58",
  "letter": "W"
}, {
  "short": "VN",
  "name": "越南",
  "en": "Vietnam",
  "tel": "84",
  "letter": "Y"
}, {
  "short": "YE",
  "name": "也门",
  "en": "Yemen",
  "tel": "967",
  "letter": "Y"
}, {
  "short": "YU",
  "name": "南斯拉夫",
  "en": "Yugoslavia",
  "tel": "381",
  "letter": "N"
}, {
  "short": "ZA",
  "name": "南非",
  "en": "South Africa",
  "tel": "27",
  "letter": "N"
}, {
  "short": "ZM",
  "name": "赞比亚",
  "en": "Zambia",
  "tel": "260",
  "letter": "Z"
}, {
  "short": "ZR",
  "name": "扎伊尔",
  "en": "Zaire",
  "tel": "243",
  "letter": "Z"
}, {
  "short": "ZW",
  "name": "津巴布韦",
  "en": "Zimbabwe",
  "tel": "263",
  "letter": "J"
}
]

export let areaCodeEN = [{
  "short": "AD",
  "name": "安道尔共和国",
  "en": "Andorra",
  "tel": "376",
  "letter": "A"
},  {
  "short": "AF",
  "name": "阿富汗",
  "en": "Afghanistan",
  "tel": "93",
  "letter": "A"
}, {
  "short": "AG",
  "name": "安提瓜和巴布达",
  "en": "Antigua and Barbuda",
  "tel": "1268",
  "letter": "A"
}, {
  "short": "AI",
  "name": "安圭拉岛",
  "en": "Anguilla",
  "tel": "1264",
  "letter": "A"
}, {
  "short": "AL",
  "name": "阿尔巴尼亚",
  "en": "Albania",
  "tel": "355",
  "letter": "A"
}, {
  "short": "AM",
  "name": "亚美尼亚",
  "en": "Armenia",
  "tel": "374",
  "letter": "A"
}, {
  "short": "",
  "name": "阿森松",
  "en": "Ascension",
  "tel": "247",
  "letter": "A"
}, {
  "short": "AO",
  "name": "安哥拉",
  "en": "Angola",
  "tel": "244",
  "letter": "A"
}, {
  "short": "AR",
  "name": "阿根廷",
  "en": "Argentina",
  "tel": "54",
  "letter": "A"
}, {
  "short": "AT",
  "name": "奥地利",
  "en": "Austria",
  "tel": "43",
  "letter": "A"
}, {
  "short": "AU",
  "name": "澳大利亚",
  "en": "Australia",
  "tel": "61",
  "letter": "A"
}, {
  "short": "AZ",
  "name": "阿塞拜疆",
  "en": "Azerbaijan",
  "tel": "994",
  "letter": "A"
}, {
  "short": "DZ",
  "name": "阿尔及利亚",
  "en": "Algeria",
  "tel": "213",
  "letter": "A"
}, {
  "short": "BB",
  "name": "巴巴多斯",
  "en": "Barbados",
  "tel": "1246",
  "letter": "B"
}, {
  "short": "BD",
  "name": "孟加拉国",
  "en": "Bangladesh",
  "tel": "880",
  "letter": "B"
}, {
  "short": "BE",
  "name": "比利时",
  "en": "Belgium",
  "tel": "32",
  "letter": "B"
}, {
  "short": "BF",
  "name": "布基纳法索",
  "en": "Burkina-faso",
  "tel": "226",
  "letter": "B"
}, {
  "short": "BG",
  "name": "保加利亚",
  "en": "Bulgaria",
  "tel": "359",
  "letter": "B"
}, {
  "short": "BH",
  "name": "巴林",
  "en": "Bahrain",
  "tel": "973",
  "letter": "B"
}, {
  "short": "BI",
  "name": "布隆迪",
  "en": "Burundi",
  "tel": "257",
  "letter": "B"
}, {
  "short": "BJ",
  "name": "贝宁",
  "en": "Benin",
  "tel": "229",
  "letter": "B"
}, {
  "short": "BM",
  "name": "百慕大群岛",
  "en": "Bermuda Is.",
  "tel": "1441",
  "letter": "B"
}, {
  "short": "BN",
  "name": "文莱",
  "en": "Brunei",
  "tel": "673",
  "letter": "B"
}, {
  "short": "BO",
  "name": "玻利维亚",
  "en": "Bolivia",
  "tel": "591",
  "letter": "B"
}, {
  "short": "BR",
  "name": "巴西",
  "en": "Brazil",
  "tel": "55",
  "letter": "B"
}, {
  "short": "BS",
  "name": "巴哈马",
  "en": "Bahamas",
  "tel": "1242",
  "letter": "B"
}, {
  "short": "BW",
  "name": "博茨瓦纳",
  "en": "Botswana",
  "tel": "267",
  "letter": "B"
}, {
  "short": "BY",
  "name": "白俄罗斯",
  "en": "Belarus",
  "tel": "375",
  "letter": "B"
}, {
  "short": "BZ",
  "name": "伯利兹",
  "en": "Belize",
  "tel": "501",
  "letter": "B"
},  {
  "short": "TD",
  "name": "乍得",
  "en": "Chad",
  "tel": "235",
  "letter": "C"
}, {
  "short": "CA",
  "name": "加拿大",
  "en": "Canada",
  "tel": "1",
  "letter": "C"
}, {
  "short": "",
  "name": "开曼群岛",
  "en": "Cayman Is.",
  "tel": "1345",
  "letter": "C"
}, {
  "short": "CF",
  "name": "中非共和国",
  "en": "Central African Republic",
  "tel": "236",
  "letter": "C"
}, {
  "short": "CG",
  "name": "刚果",
  "en": "Congo",
  "tel": "242",
  "letter": "C"
}, {
  "short": "CK",
  "name": "库克群岛",
  "en": "Cook Is.",
  "tel": "682",
  "letter": "C"
}, {
  "short": "CL",
  "name": "智利",
  "en": "Chile",
  "tel": "56",
  "letter": "C"
}, {
  "short": "CM",
  "name": "喀麦隆",
  "en": "Cameroon",
  "tel": "237",
  "letter": "C"
}, {
  "short": "CN",
  "name": "中国",
  "en": "China",
  "tel": "86",
  "letter": "C"
}, {
  "short": "CO",
  "name": "哥伦比亚",
  "en": "Colombia",
  "tel": "57",
  "letter": "C"
}, {
  "short": "CR",
  "name": "哥斯达黎加",
  "en": "Costa Rica",
  "tel": "506",
  "letter": "C"
},
{
  "short": "CU",
  "name": "古巴",
  "en": "Cuba",
  "tel": "53",
  "letter": "C"
}, {
  "short": "CY",
  "name": "塞浦路斯",
  "en": "Cyprus",
  "tel": "357",
  "letter": "C"
}, {
  "short": "CZ",
  "name": "捷克",
  "en": "Czech Republic",
  "tel": "420",
  "letter": "C"
}, {
  "short": "DE",
  "name": "德国",
  "en": "Germany",
  "tel": "49",
  "letter": "G"
}, {
  "short": "DJ",
  "name": "吉布提",
  "en": "Djibouti",
  "tel": "253",
  "letter": "d"
}, {
  "short": "DK",
  "name": "丹麦",
  "en": "Denmark",
  "tel": "45",
  "letter": "D"
}, {
  "short": "DO",
  "name": "多米尼加共和国",
  "en": "Dominica Rep.",
  "tel": "1890",
  "letter": "D"
}, {
  "short": "EC",
  "name": "厄瓜多尔",
  "en": "Ecuador",
  "tel": "593",
  "letter": "E"
}, {
  "short": "EE",
  "name": "爱沙尼亚",
  "en": "Estonia",
  "tel": "372",
  "letter": "E"
}, {
  "short": "EG",
  "name": "埃及",
  "en": "Egypt",
  "tel": "20",
  "letter": "E"
}, {
  "short": "ES",
  "name": "西班牙",
  "en": "Spain",
  "tel": "34",
  "letter": "S"
}, {
  "short": "ET",
  "name": "埃塞俄比亚",
  "en": "Ethiopia",
  "tel": "251",
  "letter": "E"
}, {
  "short": "FI",
  "name": "芬兰",
  "en": "Finland",
  "tel": "358",
  "letter": "F"
}, {
  "short": "FJ",
  "name": "斐济",
  "en": "Fiji",
  "tel": "679",
  "letter": "F"
}, {
  "short": "FR",
  "name": "法国",
  "en": "France",
  "tel": "33",
  "letter": "F"
},{
  "short": "GF",
  "name": "法属圭亚那",
  "en": "French Guiana",
  "tel": "594",
  "letter": "F"
}, {
  "short": "GA",
  "name": "加蓬",
  "en": "Gabon",
  "tel": "241",
  "letter": "G"
}, {
  "short": "GB",
  "name": "英国",
  "en": "United Kiongdom",
  "tel": "44",
  "letter": "U"
}, {
  "short": "GD",
  "name": "格林纳达",
  "en": "Grenada",
  "tel": "1809",
  "letter": "G"
}, {
  "short": "GE",
  "name": "格鲁吉亚",
  "en": "Georgia",
  "tel": "995",
  "letter": "G"
},  {
  "short": "GH",
  "name": "加纳",
  "en": "Ghana",
  "tel": "233",
  "letter": "G"
}, {
  "short": "GI",
  "name": "直布罗陀",
  "en": "Gibraltar",
  "tel": "350",
  "letter": "G"
}, {
  "short": "GM",
  "name": "冈比亚",
  "en": "Gambia",
  "tel": "220",
  "letter": "G"
}, {
  "short": "GN",
  "name": "几内亚",
  "en": "Guinea",
  "tel": "224",
  "letter": "G"
}, {
  "short": "GR",
  "name": "希腊",
  "en": "Greece",
  "tel": "30",
  "letter": "G"
}, {
  "short": "GT",
  "name": "危地马拉",
  "en": "Guatemala",
  "tel": "502",
  "letter": "G"
}, {
  "short": "GU",
  "name": "关岛",
  "en": "Guam",
  "tel": "1671",
  "letter": "G"
}, {
  "short": "GY",
  "name": "圭亚那",
  "en": "Guyana",
  "tel": "592",
  "letter": "G"
}, {
  "short": "ChinaHK",
  "name": "中国香港特别行政区",
  "en": "China Hongkong",
  "tel": "852",
  "letter": "Z"
}, {
  "short": "HN",
  "name": "洪都拉斯",
  "en": "Honduras",
  "tel": "504",
  "letter": "H"
}, {
  "short": "HT",
  "name": "海地",
  "en": "Haiti",
  "tel": "509",
  "letter": "H"
}, {
  "short": "HU",
  "name": "匈牙利",
  "en": "Hungary",
  "tel": "36",
  "letter": "H"
}, {
  "short": "ID",
  "name": "印度尼西亚",
  "en": "Indonesia",
  "tel": "62",
  "letter": "I"
}, {
  "short": "IE",
  "name": "爱尔兰",
  "en": "Ireland",
  "tel": "353",
  "letter": "I"
}, {
  "short": "IL",
  "name": "以色列",
  "en": "Israel",
  "tel": "972",
  "letter": "I"
}, {
  "short": "IN",
  "name": "印度",
  "en": "India",
  "tel": "91",
  "letter": "I"
}, {
  "short": "IQ",
  "name": "伊拉克",
  "en": "Iraq",
  "tel": "964",
  "letter": "I"
}, {
  "short": "IR",
  "name": "伊朗",
  "en": "Iran",
  "tel": "98",
  "letter": "I"
}, {
  "short": "IS",
  "name": "冰岛",
  "en": "Iceland",
  "tel": "354",
  "letter": "I"
}, {
  "short": "IT",
  "name": "意大利",
  "en": "Italy",
  "tel": "39",
  "letter": "I"
}, {
  "short": "",
  "name": "科特迪瓦",
  "en": "Ivory Coast",
  "tel": "225",
  "letter": "I"
}, {
  "short": "JM",
  "name": "牙买加",
  "en": "Jamaica",
  "tel": "1876",
  "letter": "J"
}, {
  "short": "JO",
  "name": "约旦",
  "en": "Jordan",
  "tel": "962",
  "letter": "J"
}, {
  "short": "JP",
  "name": "日本",
  "en": "Japan",
  "tel": "81",
  "letter": "J"
}, {
  "short": "KE",
  "name": "肯尼亚",
  "en": "Kenya",
  "tel": "254",
  "letter": "K"
}, {
  "short": "KG",
  "name": "吉尔吉斯坦",
  "en": "Kyrgyzstan",
  "tel": "331",
  "letter": "k"
}, {
  "short": "KH",
  "name": "柬埔寨",
  "en": "Kampuchea (Cambodia )",
  "tel": "855",
  "letter": "k"
}, {
  "short": "KP",
  "name": "朝鲜",
  "en": "North Korea",
  "tel": "850",
  "letter": "N"
}, {
  "short": "KR",
  "name": "韩国",
  "en": "Korea",
  "tel": "82",
  "letter": "K"
}, {
  "short": "KT",
  "name": "科特迪瓦共和国",
  "en": "RepublicofIvoryCoast",
  "tel": "225",
  "letter": "R"
}, {
  "short": "KW",
  "name": "科威特",
  "en": "Kuwait",
  "tel": "965",
  "letter": "K"
}, {
  "short": "KZ",
  "name": "哈萨克斯坦",
  "en": "Kazakstan",
  "tel": "327",
  "letter": "K"
}, {
  "short": "LA",
  "name": "老挝",
  "en": "Laos",
  "tel": "856",
  "letter": "L"
}, {
  "short": "LB",
  "name": "黎巴嫩",
  "en": "Lebanon",
  "tel": "961",
  "letter": "L"
}, {
  "short": "LC",
  "name": "圣卢西亚",
  "en": "Saint Lueia",
  "tel": "1758",
  "letter": "S"
}, {
  "short": "LI",
  "name": "列支敦士登",
  "en": "Liechtenstein",
  "tel": "423",
  "letter": "L"
}, {
  "short": "LK",
  "name": "斯里兰卡",
  "en": "Sri Lanka",
  "tel": "94",
  "letter": "S"
}, {
  "short": "LR",
  "name": "利比里亚",
  "en": "Liberia",
  "tel": "231",
  "letter": "L"
}, {
  "short": "LS",
  "name": "莱索托",
  "en": "Lesotho",
  "tel": "266",
  "letter": "L"
}, {
  "short": "LT",
  "name": "立陶宛",
  "en": "Lithuania",
  "tel": "370",
  "letter": "L"
}, {
  "short": "LU",
  "name": "卢森堡",
  "en": "Luxembourg",
  "tel": "352",
  "letter": "L"
}, {
  "short": "LV",
  "name": "拉脱维亚",
  "en": "Latvia",
  "tel": "371",
  "letter": "L"
}, {
  "short": "LY",
  "name": "利比亚",
  "en": "Libya",
  "tel": "218",
  "letter": "L"
}, {
  "short": "MA",
  "name": "摩洛哥",
  "en": "Morocco",
  "tel": "212",
  "letter": "M"
}, {
  "short": "MC",
  "name": "摩纳哥",
  "en": "Monaco",
  "tel": "377",
  "letter": "M"
}, {
  "short": "MD",
  "name": "摩尔多瓦",
  "en": "Moldova Republic of",
  "tel": "373",
  "letter": "M"
}, {
  "short": "MG",
  "name": "马达加斯加",
  "en": "Madagascar",
  "tel": "261",
  "letter": "M"
}, {
  "short": "ML",
  "name": "马里",
  "en": "Mali",
  "tel": "223",
  "letter": "M"
}, {
  "short": "MM",
  "name": "缅甸",
  "en": "Burma",
  "tel": "95",
  "letter": "B"
}, {
  "short": "MN",
  "name": "蒙古",
  "en": "Mongolia",
  "tel": "976",
  "letter": "M"
}, {
  "short": "china MO",
  "name": "中国澳门",
  "en": "China Macao",
  "tel": "853",
  "letter": "C"
}, {
  "short": "MS",
  "name": "蒙特塞拉特岛",
  "en": "Montserrat Is",
  "tel": "1664",
  "letter": "M"
}, {
  "short": "MT",
  "name": "马耳他",
  "en": "Malta",
  "tel": "356",
  "letter": "M"
}, {
  "short": "",
  "name": "马里亚那群岛",
  "en": "MarianaIs",
  "tel": "1670",
  "letter": "M"
}, {
  "short": "",
  "name": "马提尼克",
  "en": "Martinique",
  "tel": "596",
  "letter": "M"
}, {
  "short": "MU",
  "name": "毛里求斯",
  "en": "Mauritius",
  "tel": "230",
  "letter": "M"
}, {
  "short": "MV",
  "name": "马尔代夫",
  "en": "Maldives",
  "tel": "960",
  "letter": "M"
}, {
  "short": "MW",
  "name": "马拉维",
  "en": "Malawi",
  "tel": "265",
  "letter": "M"
}, {
  "short": "MX",
  "name": "墨西哥",
  "en": "Mexico",
  "tel": "52",
  "letter": "M"
}, {
  "short": "MY",
  "name": "马来西亚",
  "en": "Malaysia",
  "tel": "60",
  "letter": "M"
}, {
  "short": "MZ",
  "name": "莫桑比克",
  "en": "Mozambique",
  "tel": "258",
  "letter": "M"
}, {
  "short": "NA",
  "name": "纳米比亚",
  "en": "Namibia",
  "tel": "264",
  "letter": "N"
}, {
  "short": "NE",
  "name": "尼日尔",
  "en": "Niger",
  "tel": "977",
  "letter": "N"
}, {
  "short": "NG",
  "name": "尼日利亚",
  "en": "Nigeria",
  "tel": "234",
  "letter": "N"
}, {
  "short": "NI",
  "name": "尼加拉瓜",
  "en": "Nicaragua",
  "tel": "505",
  "letter": "N"
}, {
  "short": "NL",
  "name": "荷兰",
  "en": "Netherlands",
  "tel": "31",
  "letter": "N"
}, {
  "short": "NO",
  "name": "挪威",
  "en": "Norway",
  "tel": "47",
  "letter": "N"
}, {
  "short": "NP",
  "name": "尼泊尔",
  "en": "Nepal",
  "tel": "977",
  "letter": "N"
}, {
  "short": "",
  "name": "荷属安的列斯",
  "en": "Netheriands Antilles",
  "tel": "599",
  "letter": "N"
}, {
  "short": "NR",
  "name": "瑙鲁",
  "en": "Nauru",
  "tel": "674",
  "letter": "N"
}, {
  "short": "NZ",
  "name": "新西兰",
  "en": "New Zealand",
  "tel": "64",
  "letter": "N"
}, {
  "short": "OM",
  "name": "阿曼",
  "en": "Oman",
  "tel": "968",
  "letter": "O"
}, {
  "short": "PA",
  "name": "巴拿马",
  "en": "Panama",
  "tel": "507",
  "letter": "P"
},  {
  "short": "BL",
  "name": "巴勒斯坦",
  "en": "Palestine",
  "tel": "970",
  "letter": "P"
},{
  "short": "PE",
  "name": "秘鲁",
  "en": "Peru",
  "tel": "51",
  "letter": "P"
}, {
  "short": "PF",
  "name": "法属玻利尼西亚",
  "en": "French Polynesia",
  "tel": "689",
  "letter": "F"
}, {
  "short": "PG",
  "name": "巴布亚新几内亚",
  "en": "Papua New Cuinea",
  "tel": "675",
  "letter": "P"
}, {
  "short": "PH",
  "name": "菲律宾",
  "en": "Philippines",
  "tel": "63",
  "letter": "P"
}, {
  "short": "PK",
  "name": "巴基斯坦",
  "en": "Pakistan",
  "tel": "92",
  "letter": "P"
}, {
  "short": "PL",
  "name": "波兰",
  "en": "Poland",
  "tel": "48",
  "letter": "P"
}, {
  "short": "PR",
  "name": "波多黎各",
  "en": "Puerto Rico",
  "tel": "1787",
  "letter": "P"
}, {
  "short": "PT",
  "name": "葡萄牙",
  "en": "Portugal",
  "tel": "351",
  "letter": "P"
}, {
  "short": "PY",
  "name": "巴拉圭",
  "en": "Paraguay",
  "tel": "595",
  "letter": "P"
}, {
  "short": "QA",
  "name": "卡塔尔",
  "en": "Qatar",
  "tel": "974",
  "letter": "Q"
}, {
  "short": "",
  "name": "留尼旺",
  "en": "Reunion",
  "tel": "262",
  "letter": "R"
}, {
  "short": "RO",
  "name": "罗马尼亚",
  "en": "Romania",
  "tel": "40",
  "letter": "R"
}, {
  "short": "RU",
  "name": "俄罗斯",
  "en": "Russia",
  "tel": "7",
  "letter": "R"
}, {
  "short": "CH",
  "name": "瑞士",
  "en": "Switzerland",
  "tel": "41",
  "letter": "S"
}, {
  "short": "SA",
  "name": "沙特阿拉伯",
  "en": "Saudi Arabia",
  "tel": "966",
  "letter": "S"
}, {
  "short": "SB",
  "name": "所罗门群岛",
  "en": "Solomon Is",
  "tel": "677",
  "letter": "S"
}, {
  "short": "SC",
  "name": "塞舌尔",
  "en": "Seychelles",
  "tel": "248",
  "letter": "S"
}, {
  "short": "SD",
  "name": "苏丹",
  "en": "Sudan",
  "tel": "249",
  "letter": "S"
}, {
  "short": "SE",
  "name": "瑞典",
  "en": "Sweden",
  "tel": "46",
  "letter": "S"
}, {
  "short": "SG",
  "name": "新加坡",
  "en": "Singapore",
  "tel": "65",
  "letter": "S"
}, {
  "short": "SI",
  "name": "斯洛文尼亚",
  "en": "Slovenia",
  "tel": "386",
  "letter": "S"
}, {
  "short": "SK",
  "name": "斯洛伐克",
  "en": "Slovakia",
  "tel": "421",
  "letter": "S"
}, {
  "short": "SL",
  "name": "塞拉利昂",
  "en": "Sierra Leone",
  "tel": "232",
  "letter": "S"
}, {
  "short": "SM",
  "name": "圣马力诺",
  "en": "San Marino",
  "tel": "378",
  "letter": "S"
}, {
  "short": "",
  "name": "东萨摩亚(美)",
  "en": "Samoa Eastern",
  "tel": "684",
  "letter": "S"
}, {
  "short": "",
  "name": "西萨摩亚",
  "en": "Samoa Western",
  "tel": "685",
  "letter": "S"
}, {
  "short": "SN",
  "name": "塞内加尔",
  "en": "Senegal",
  "tel": "221",
  "letter": "S"
}, {
  "short": "SO",
  "name": "索马里",
  "en": "Somali",
  "tel": "252",
  "letter": "S"
}, {
  "short": "SR",
  "name": "苏里南",
  "en": "Suriname",
  "tel": "597",
  "letter": "S"
}, {
  "short": "ST",
  "name": "圣多美和普林西比",
  "en": "Sao Tome and Principe",
  "tel": "239",
  "letter": "S"
}, {
  "short": "SV",
  "name": "萨尔瓦多",
  "en": "EI Salvador",
  "tel": "503",
  "letter": "E"
}, {
  "short": "SY",
  "name": "叙利亚",
  "en": "Syria",
  "tel": "963",
  "letter": "S"
}, {
  "short": "SZ",
  "name": "斯威士兰",
  "en": "Swaziland",
  "tel": "268",
  "letter": "S"
}, {
  "short": "TD",
  "name": "乍得",
  "en": "Chad",
  "tel": "235",
  "letter": "C"
}, {
  "short": "TG",
  "name": "多哥",
  "en": "Togo",
  "tel": "228",
  "letter": "T"
}, {
  "short": "TH",
  "name": "泰国",
  "en": "Thailand",
  "tel": "66",
  "letter": "T"
}, {
  "short": "TJ",
  "name": "塔吉克斯坦",
  "en": "Tajikstan",
  "tel": "992",
  "letter": "T"
}, {
  "short": "TM",
  "name": "土库曼斯坦",
  "en": "Turkmenistan",
  "tel": "993",
  "letter": "T"
}, {
  "short": "TN",
  "name": "突尼斯",
  "en": "Tunisia",
  "tel": "216",
  "letter": "T"
}, {
  "short": "TO",
  "name": "汤加",
  "en": "Tonga",
  "tel": "676",
  "letter": "T"
}, {
  "short": "TR",
  "name": "土耳其",
  "en": "Turkey",
  "tel": "90",
  "letter": "T"
}, {
  "short": "TT",
  "name": "特立尼达和多巴哥",
  "en": "Trinidad and Tobago",
  "tel": "1809",
  "letter": "T"
}, {
  "short": " china TW",
  "name": "中国台湾省",
  "en": "China Taiwan",
  "tel": "886",
  "letter": "C"
}, {
  "short": "TZ",
  "name": "坦桑尼亚",
  "en": "Tanzania",
  "tel": "255",
  "letter": "T"
}, {
  "short": "UA",
  "name": "乌克兰",
  "en": "Ukraine",
  "tel": "380",
  "letter": "U"
}, {
  "short": "UG",
  "name": "乌干达",
  "en": "Uganda",
  "tel": "256",
  "letter": "U"
}, {
  "short": "US",
  "name": "美国",
  "en": "United States of America",
  "tel": "1",
  "letter": "U"
}, {
  "short": "UY",
  "name": "乌拉圭",
  "en": "Uruguay",
  "tel": "598",
  "letter": "U"
}, {
  "short": "UZ",
  "name": "乌兹别克斯坦",
  "en": "Uzbekistan",
  "tel": "233",
  "letter": "U"
}, {
  "short": "VC",
  "name": "圣文森特岛",
  "en": "Saint Vincent",
  "tel": "1784",
  "letter": "S"
}, {
  "short": "VE",
  "name": "委内瑞拉",
  "en": "Venezuela",
  "tel": "58",
  "letter": "V"
}, {
  "short": "VN",
  "name": "越南",
  "en": "Vietnam",
  "tel": "84",
  "letter": "V"
}, {
  "short": "YE",
  "name": "也门",
  "en": "Yemen",
  "tel": "967",
  "letter": "Y"
}, {
  "short": "YU",
  "name": "南斯拉夫",
  "en": "Yugoslavia",
  "tel": "381",
  "letter": "Y"
}, {
  "short": "ZA",
  "name": "南非",
  "en": "South Africa",
  "tel": "27",
  "letter": "S"
}, {
  "short": "ZM",
  "name": "赞比亚",
  "en": "Zambia",
  "tel": "260",
  "letter": "Z"
}, {
  "short": "ZR",
  "name": "扎伊尔",
  "en": "Zaire",
  "tel": "243",
  "letter": "Z"
}, {
  "short": "ZW",
  "name": "津巴布韦",
  "en": "Zimbabwe",
  "tel": "263",
  "letter": "Z"
},{
  "short": "AE",
  "name": "阿拉伯联合酋长国",
  "en": "United Arab Emirates",
  "tel": "971",
  "letter": "U"
},
]


//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = null
// module chunks = 